module.exports = __webpack_public_path__ + "static/media/power-def3.1a19b89f.png";